var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon16PxEyeHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.404 4.11a.5.5 0 0 0 0 .708l.934.935A7.377 7.377 0 0 0 3.042 7.8a.5.5 0 0 0 0 .4C4.052 10.545 5.95 12 8 12c.72 0 1.421-.18 2.072-.514l1.11 1.11a.5.5 0 0 0 .707-.707L4.111 4.111a.5.5 0 0 0-.707 0Zm5.914 6.622-.8-.8a2.002 2.002 0 0 1-2.45-2.45l-1.02-1.02A6.322 6.322 0 0 0 4.051 8C4.916 9.855 6.415 11 8 11c.45 0 .894-.093 1.318-.268Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.932 8.517-2.45-2.45a2.001 2.001 0 0 1 2.45 2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.949 8a6.323 6.323 0 0 1-.998 1.537l.71.71A7.376 7.376 0 0 0 12.958 8.2a.5.5 0 0 0 0-.4C11.948 5.455 10.05 4 8 4c-.72 0-1.421.18-2.072.514l.754.754A3.443 3.443 0 0 1 8 5c1.584 0 3.084 1.145 3.949 3Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon16PxEyeHide);
export default __webpack_public_path__ + "static/media/4-icon-16-px-eye-hide.ca5d4ebe.svg";
export { ForwardRef as ReactComponent };